<template>
  <div v-if="visible">
    <h3>Voorzieningen</h3>
    <table class="table table-condensed">
      <tbody>
        <template v-for="row in rows">
          <tr
            v-if="rowVisible(row)"
            :key="row.title"
          >
            <th>{{ row.title }}</th>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <td v-html="row.value" />
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    school: {
      required: true,
      type: Object,
    },
  },
  data() {
    const { school } = this;

    let kostenTsoValue = '&euro; ';
    if (school.tso_kosten) {
      kostenTsoValue += `${school.tso_kosten} `;
    }
    if (school.tso_termijn && school.tso_termijn !== 'onbekend') {
      kostenTsoValue += ` per ${school.tso_termijn} `;
    }
    if (school.tso_toelichting) {
      kostenTsoValue += `(${school.tso_toelichting})`;
    }

    const showKostenTso = (isset(school.tso_kosten)
        && school.tso_kosten !== '0'
        && school.tso_kosten !== '0.00'
        && isset(school.tso_termijn))
      || isset(school.tso_toelichting);

    return {
      rows: [
        {
          title: 'organisatie tussenschoolse opvang (tso)',
          value: school.tso,
        },
        {
          title: 'kosten tso',
          value: kostenTsoValue,
          show: showKostenTso,
        },
        {
          title: 'nso aanbieder',
          value: school.nso_aanbieder,
        },

        {
          title: 'schoolgebouw',
          value: school.schoolgebouw,
        },
        {
          title: 'bereikbaarheid',
          value: school.bereikbaarheid,
        },
        {
          title: 'elo',
          value: false,
        },
        {
          title: 'veiligheid',
          value: school.veiligheid,
        },
        {
          title: 'kantine',
          value: school.kantine,
        },
      ],
    };
  },
  computed: {
    visible() {
      if (!this.rows) {
        return false;
      }
      const visibleRow = this.rows.find((row) => this.rowVisible(row));
      return isset(visibleRow);
    },
  },
  methods: {
    rowVisible(row) {
      return row.show === true || (row.show === undefined && row.value);
    },
  },
};

function isset(value) {
  return !!value;
}
</script>
